export default __webpack_public_path__ + "static/media/grid-active.23e056fa.svg";